interface Props {
  statValue: number;
  statTitle: string;
  statIcon: React.ReactNode;
  statIconBgColor: string;
}
function StatisticsCard({
  statValue,
  statTitle,
  statIcon,
  statIconBgColor,
}: Props) {
  return (
    <div className="flex sm:flex-row flex-col justify-between items-center rounded-md h-full w-full p-5 bg-white outline outline-2 outline-gray-100">
      {/* Left side: Pending Requests */}
      <div className="flex flex-col sm:items-start items-center">
        <div className="font-bold lg:text-xl text-l">{statValue}</div>
        <div className="lg:text-sm text-xs text-gray-500 sm:w-1/4 lg:w-auto text-center">{statTitle}</div>
      </div>

      {/* Right side: Icon inside a square */}
      <div
        className={`sm:p-3 p-1 aspect-square flex items-center justify-center rounded-md ${statIconBgColor}`}
      >
        {statIcon}
      </div>
    </div >
  );
}

export default StatisticsCard;